import { useOffline } from '../../hooks/useOffline';
import { useOfflineStore } from '../../stores/offlineStore';

export default function OfflineIndicator() {
  const { isOnline } = useOffline();
  const pendingSyncs = useOfflineStore((s) => s.pendingSyncs);

  if (isOnline && pendingSyncs.length === 0) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-toast text-center font-sans text-xs py-1.5 font-medium transition-all duration-normal ${
        isOnline
          ? 'bg-success-muted text-success'
          : 'bg-warning-muted text-warning'
      }`}
    >
      {isOnline
        ? `Back online — syncing ${pendingSyncs.length} change${pendingSyncs.length !== 1 ? 's' : ''}…`
        : 'Offline — changes will sync when you reconnect'}
    </div>
  );
}
